<template>
    <base-container :isLoading="isLoading">
        <!-- <van-nav-bar title="预约挂号" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
        <div id="appdiv">
            <div class="container">
                <div class="appointmentinfo">
                    <div class="flex_list">
                        <ul>
                            <li>
                                <span>挂号类型：</span>
                                <span>专家号</span>
                            </li>
                            <li>
                                <span>挂号医生：</span>
                                <span>{{registerConfirmationInfo.doctorName}}</span>
                            </li>
                            <li>
                                <span>挂号科室：</span>
                                <span>{{registerConfirmationInfo.deptName}}</span>
                            </li>
                            <li>
                                <span>挂号日期：</span>
                                <span>{{registerConfirmationInfo.visitDate}}({{registerConfirmationInfo.visitWeek}})</span>
                            </li>
                            <li>
                                <span>挂号时段：</span>
                                <span>{{registerConfirmationInfo.startTime}}-{{registerConfirmationInfo.endTime}}</span>
                            </li>
                            <li>
                                <span>挂号费：</span>
                                <span>{{registerConfirmationInfo.regFee}}元</span>
                            </li>
                            <li>
                                <span>诊疗费：</span>
                                <span>{{registerConfirmationInfo.treatFee}}元</span>
                            </li>
                            <li>
                                <span>挂号总费用：</span>
                                <span class="name">{{registerConfirmationInfo.resRegAmount}}元</span>
                            </li>
                        </ul>
                    </div>
                    <div class="AppointmentDetail">
                        <section>
                            <p>请选择就诊人</p>
                            <div class="users">
                                <ul>
                                    <span v-if="isLogin&&user.cusMedicalCards!=null&&user.cusMedicalCards.length>0">
                                        <li @click="changeCheckUser(cusMedInfo)"
                                            :class="{checkUser:checkUsesMedInfo.cardNo==cusMedInfo.cardNo}"
                                            v-for="(cusMedInfo,index) in user.cusMedicalCards" :key="index">
                                            <h3>{{cusMedInfo.patientName}}</h3>
                                            <p>{{cusMedInfo.cardNo}}</p>
                                        </li>
                                    </span>
                                    <li class="add_user"
                                        v-if="isLogin&&user.cusMedicalCards!=null&&user.cusMedicalCards.length>0">
                                        <p @click="goToLogin(1)">
                                            <i></i>切换就诊人
                                        </p>
                                    </li>
                                    <li class="add_user" v-if="isLogin&&user.cusMedicalCards.length==0">
                                        <p @click="goToLogin(1)">
                                            <i></i>添加就诊人
                                        </p>
                                    </li>
                                    <li class="add_user" v-if="!isLogin">
                                        <p @click="goToLogin(0)">
                                            <i></i>登录
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <section>
                            <div class="chosePay">
                                <van-button v-if="!isLogin" type="primary" size="large" round @click="goToPay()"
                                    icon="alipay" color="#DDDDDD">请先登录</van-button>
                                <van-button v-else type="primary" size="large" :disabled="disclick" round
                                    @click="goToPay()" icon="alipay" color="#1989fa">确认支付</van-button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="show" round position="bottom" :style="{ height: '60%' }">
            <van-form @submit="onSubmit">
                <van-field v-model="formParams.patientName" name="patientName" label="姓名" placeholder="姓名"
                    :rules="[{ required: false, message: '请填写姓名' }]" />
                <van-field v-model="formParams.idNo" name="idNo" label="身份证号" placeholder="身份证号"
                    :rules="[{ required: true, message: '请填写正确的身份证号',validator:validIdNo }]" />
                <van-field v-model="formParams.phone" name="phone" label="手机号码" placeholder="手机号码"
                    :rules="[{ required: true, message: '请填写正确的手机号码',validator:validPhone }]" />
                <van-field v-model="formParams.addres" name="addres" label="详细地址" placeholder="详细地址"
                    :rules="[{ required: false, message: '请填写详细地址' }]" />
                <van-field name="radio" label="是否去过医院就诊">
                    <template #input>
                        <van-radio-group v-model="formParams.radio" direction="horizontal">
                            <van-radio name="0" checked-color="#07c160">是</van-radio>
                            <van-radio name="1" checked-color="#07c160">否</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field v-if="formParams.radio==0" v-model="formParams.cardNo" name="cardNo" label="就诊卡号"
                    placeholder="就诊卡号" :rules="[{ required: false, message: '请填写就诊卡号' }]" />
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" color="#07c160">提交</van-button>
                </div>
            </van-form>
        </van-popup>
    </base-container>
</template>
<script>
    import "@/assets/css/reset.css?=2";
    import "@/assets/css/comman.css?=2";
    import "@/assets/css/AppointmentInfo.css?=2";
    import "@/assets/css/AppointmentDetail.css?=2";
    import { Notify } from "vant";
    import { getUserInfo } from "@/api/customer";
    import { isMobile, cardid } from "@/util/validate";
    import { isLogin } from "@/util/auth";
    import { certnoGetInfo, getRandomInt, getCurrentDateTime } from "@/util/common";
    import { BindArchives, GetPatientInfo } from "@/api/hos";
    import { BindMedicalCard } from "@/api/customer";
    import { CreateOrder } from "@/api/order";

    export default {
        props: ["orgCode", "deptCode", "cliunitId", "resRegAmount", "timePeriod"],
        data() {
            return {
                isLoading: false,
                show: false,
                registerConfirmationInfo: {
                    orgCode: this.orgCode,
                    cliunitId: this.cliunitId,
                    resRegAmount: this.resRegAmount,
                    timePeriod: this.timePeriod,
                    doctorName: this.$route.params.doctorName,
                    deptCode: this.deptCode,
                    deptName: this.$route.params.deptName,
                    visitDate: this.$route.params.visitDate,
                    visitWeek: this.$route.params.visitWeek,
                    visitTimeFlag: this.$route.params.visitTimeFlag,
                    regFee: this.$route.params.regFee,
                    treatFee: this.$route.params.treatFee,
                    startTime: this.$route.params.startTime,
                    endTime: this.$route.params.endTime,
                },
                user: {
                    cusWaterfeeInfos: [],
                    cusMedicalCards: [],
                }, //患者信息集合
                disclick: true,
                isLogin: false, //是否已登录系统
                formParams: {
                    patientName: "",
                    idNo: "",
                    phone: "",
                    addres: "",
                    radio: "1",
                    cardNo: "",
                }, //添加绑定就诊卡form数据
                checkUsesMedInfo: {
                    patientId: "",
                    cardNo: "",
                    patientName: "",
                }, //选中的就诊卡信息
                payInfo: {
                    payType: "",
                    payTypeName: "",
                    payAmount: 0,
                }, //支付信息
                orderInfo: {
                    payAmount: 0,
                    merBillNo: "", //商户订单号-前端生成
                    billNo: "", //系统订单号-平台返回
                    isPayConfirm: false, //支付确认是否成功
                    isOrderConfirm: false, //确认订单是否成功
                }, //订单信息
                hisPatientInfo: {
                    patientId: "",
                }, //建档绑卡患者信息
                isTestPay: false, //是否虚拟支付
            };
        },
        created() {
            if (isLogin()) {
                this.isLogin = true;
                this.getUserInfo();
            }
            //console.log("registerConfirmationInfo",this.registerConfirmationInfo);
        },
        methods: {
            getUserInfo() {
                this.isLoading = true;
                getUserInfo().then((res) => {
                    //console.log(res.data.value);
                    if (res.data.value != null) {
                        this.user = res.data.value;
                        this.formParams.phone = this.user.phone;
                        if (this.user.cusMedicalCards.length > 0) {
                            this.disclick = false;
                            this.checkUsesMedInfo = this.user.cusMedicalCards[0];
                        } else {
                            this.disclick = true;
                        }
                    }
                    this.isLoading = false;
                });
            },
            changeCheckUser(cusMedInfo) {
                this.checkUsesMedInfo = cusMedInfo;
            },
            goToPay() {
                this.orderInfo.payAmount = this.registerConfirmationInfo.resRegAmount;
                this.payInfo.payType = "1";
                this.payInfo.payTypeName = "支付宝支付";
                this.payInfo.PayCode = "AliPay";
                this.payInfo.payAmount = this.registerConfirmationInfo.resRegAmount;
                this.isLoading = true;
                //测试代码
                if (this.isTestPay) {
                    this.payInfo.payAmount = "0.01";
                    this.orderInfo.payAmount = "0.01";
                    this.registerConfirmationInfo.resRegAmount = "0.01";
                }
                //创建订单
                this.funCreateOrder().then((res) => {
                    //console.log(res);
                    if (res.data.value != null) {
                        this.orderInfo.billNo = res.data.value.billNo;
                        if (this.orderInfo.billNo != "") {
                            //this.toParamPage("reserveRegisterSuccess", { billNo: this.orderInfo.billNo });
                            //console.log(this.orderInfo.billNo);
                            this.toPage("startpay", {
                                billNo: this.orderInfo.billNo,
                                busType: "ReserveRegister",
                                payType: "AliPay",
                                amount: this.payInfo.payAmount,
                            });
                            this.isLoading = false;
                        }
                    }
                });
            },
            //创建订单
            funCreateOrder() {
                this.orderInfo.merBillNo =
                    getCurrentDateTime() + getRandomInt(100000, 999999);
                //创建订单
                var dataCreateOrder = {
                    merBillNo: this.orderInfo.merBillNo,
                    payType: this.payInfo.PayCode,
                    busType: "ReserveRegister",
                    amount: this.orderInfo.payAmount,
                    remark: "预约挂号",
                    reserveRegisterInfo: {
                        hisPatientId: this.checkUsesMedInfo.patientId,
                        patientName: this.checkUsesMedInfo.patientName,
                        deptName: this.registerConfirmationInfo.deptName,
                        docName: this.registerConfirmationInfo.doctorName,
                        visitDate: this.registerConfirmationInfo.visitDate,
                        visitWeek: this.registerConfirmationInfo.visitWeek,
                        visitTime:
                            this.registerConfirmationInfo.startTime +
                            "-" +
                            this.registerConfirmationInfo.endTime,
                        clinicUnit: this.registerConfirmationInfo.cliunitId,
                        timePeriod: this.registerConfirmationInfo.timePeriod,
                        registrationFee: this.registerConfirmationInfo.regFee,
                        treatFee: this.registerConfirmationInfo.treatFee,
                        medicineFee: 0,
                        payAmount: this.orderInfo.payAmount,
                        hosName: "随州中心医院",
                        hosAreaCode: this.registerConfirmationInfo.orgCode,
                        hosAreaName:
                            this.registerConfirmationInfo.orgCode == "01"
                                ? "龙门院区"
                                : this.registerConfirmationInfo.orgCode == "02"
                                    ? "季梁院区"
                                    : "文帝院区",
                    },
                };
                return CreateOrder(dataCreateOrder);
            },
            //平台绑卡
            funBindMedicalCard() {
                var dataBindMedicalCard = {
                    cardNo: this.hisPatientInfo.cardNo,
                    patientId: this.hisPatientInfo.patientId,
                    patientName: this.hisPatientInfo.name,
                    medicalRecordNo: this.hisPatientInfo.medRecoNo,
                    gender: this.hisPatientInfo.gender,
                    birthday: this.hisPatientInfo.birthday,
                    idNo: this.hisPatientInfo.idNumber,
                    phone: this.hisPatientInfo.phone,
                    hosNo: "",
                    hosName: "",
                };
                return BindMedicalCard(dataBindMedicalCard);
            },
            //HIS建档
            funHISBindArchives() {
                var perinfo = certnoGetInfo(this.formParams.idNo);
                var dataBindArchives = {
                    name: this.formParams.patientName,
                    birthday: perinfo.birth,
                    idNumber: this.formParams.idNo,
                    gender: perinfo.gender,
                    phone: this.formParams.phone,
                    address: this.formParams.addres,
                };
                return BindArchives(dataBindArchives);
            },
            //HIS查询患者信息
            funHISGetPatientInfo() {
                var queryGetPatientInfo = {
                    cardNo: this.formParams.cardNo,
                    name: this.formParams.patientName,
                };
                return GetPatientInfo(queryGetPatientInfo);
            },
            onSubmit() {
                if (this.formParams.patientName == "") {
                    Notify({
                        type: "danger",
                        message: "姓名不能为空",
                        duration: 1000,
                    });
                    return;
                }
                if (this.formParams.radio == "1" && this.formParams.idNo == "") {
                    Notify({
                        type: "danger",
                        message: "身份证号不能为空",
                        duration: 1000,
                    });
                    return;
                }
                if (this.formParams.radio == "0" && this.formParams.cardNo == "") {
                    Notify({
                        type: "danger",
                        message: "就诊卡号不能为空",
                        duration: 1000,
                    });
                    return;
                }

                //如果未去过医院就诊，则调用HIS身份证建档
                //去过医院就诊且就诊卡号不为空，则使用就诊卡查询患者信息
                if (
                    this.isLogin &&
                    this.formParams.radio == "1" &&
                    this.formParams.idNo != ""
                ) {
                    this.isLoading = true;
                    this.funHISBindArchives().then((res) => {
                        if (
                            this.isLogin &&
                            res.data.value != null &&
                            res.data.value.cardNo != ""
                        ) {
                            this.hisPatientInfo.cardNo = res.data.value.cardNo;
                            if (this.hisPatientInfo.cardNo != "") {
                                var perinfo = certnoGetInfo(this.formParams.idNo);
                                //this.hisPatientInfo.cardNo = this.formParams.idNo;
                                this.hisPatientInfo.name = this.formParams.patientName;
                                this.hisPatientInfo.medRecoNo = "";
                                this.hisPatientInfo.gender = perinfo.gender;
                                this.hisPatientInfo.birthday = perinfo.birth;
                                this.hisPatientInfo.idNumber = this.formParams.idNo;
                                this.hisPatientInfo.phone = this.formParams.phone;
                                this.funBindMedicalCard().then((res) => {
                                    if (res.data != null) {
                                        this.getUserInfo();
                                        this.show = false;
                                    }
                                });
                            }
                            this.isLoading = false;
                        }
                    });
                } else if (
                    this.isLogin &&
                    this.formParams.radio == "0" &&
                    this.formParams.cardNo != ""
                ) {
                    this.funHISGetPatientInfo().then((res) => {
                        if (
                            this.isLogin &&
                            res.data.value != null &&
                            res.data.value.patientId != ""
                        ) {
                            this.hisPatientInfo = res.data.value;
                            if (this.isLogin && this.hisPatientInfo.patientId != "") {
                                this.hisPatientInfo.birthday = this.hisPatientInfo.birthday.replace(
                                    /^(\d{4})(\d{2})(\d{2})$/,
                                    "$1-$2-$3"
                                );
                                if (this.funBindMedicalCard()) {
                                    this.getUserInfo();
                                    this.show = false;
                                }
                                this.isLoading = false;
                            }
                        } else {
                            Notify({
                                type: "danger",
                                message: "该就诊卡未获取到患者信息",
                                duration: 1000,
                            });
                            return;
                        }
                    });
                }
            },
            validIdNo(val) {
                var res = cardid(val);
                return !res[0];
            },
            validPhone(val) {
                return isMobile(val);
            },
            goToLogin(type) {
                if (type == 0) {
                    this.toPage("login", {});
                } else {
                    this.show = true;
                }
            },
            toPage(path, query) {
                //console.log("path:",path);
                //console.log("query:",query);
                this.$router.push({ path, query });
            },
            toParamPage(name, params) {
                this.$router.push({ name, params });
            },
        },
    };
</script>

<style>
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .van-circle__text {
        color: #09bb07;
        font-weight: bold;
        font-size: 0.9375rem;
    }
</style>